import React from 'react';
import './OurValue.css';

const OurValue = () => {
  return (
    <div className='wp_ourvalue_wrap'>
        <div className="container wp_ourvalue_content">
            <h1>Our Core Values</h1>
           <div className="wp_ourvalue_card">
            <div className="card">
                <div className="card-body">
                    <div className="card-title">01 - Integrity</div>
                    <div className="card-text">
                        We do what we say we will do, every time.
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="card-title">02 - Technical Excellence</div>
                    <div className="card-text">Specialist knowledge built over 25 years.</div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="card-title"> 03 - Client-First</div>
                    <div className="card-text">Every project, every client, treated as our most important.</div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="card-title"> 04 - Safety</div>
                    <div className="card-text">Zero compromise on HSE standards across all sites.</div>
                </div>
            </div>
           </div>
        </div>
    </div>
  )
}

export default OurValue